import Vue from "vue";
import axios from "axios";
import qs from "qs";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
export default {
  name: "inputPengukuran",
  data: () => ({
    idCompany: "",
    error: "",
    loader: "",
    iL: "",
    S: "",
    M: "",
    E: "",
    o: "",
    objekUkur: "",
    atribut: "",
    del: "Hapus",
    node_send: process.env.VUE_APP_NODE_MACINARY,
    layanan: [
      {
        field: "",
        ability: ""
      }
    ],
    software: [
      {
        modelSoftware: "",
        keterangan: ""
      }
    ],
    mesin: [
      {
        modelMesin: "",
        jumlahMesin: ""
      }
    ],
    electric: [
      {
        modelElectric: "",
        jumlahElectric: ""
      }
    ],
    sdm: [
      {
        role: "",
        local: "",
        asing: ""
      }
    ]
  }),
  methods: {
    conection: function(url, methods) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token,
          "Content-Type": "application/json"
        },
        url: this.node_send + url
      };
      return axios(data_send);
    },

    deleteConection: function(url, methods, remove) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: qs.stringify(remove),
        url: this.node_send + url
      };
      return axios(data_send);
    },
    dataConection: function(url, methods, data) {
      let data_send = {
        method: methods,
        headers: {
          Authorization: "Bearer " + this.Token,
          "Content-Type": "application/json"
        },
        data: data,
        url: this.node_send + url
      };
      return axios(data_send);
    },

    newData: function() {
      this.layanan.push({
        jenis: "",
        layanan: ""
      });
    },
    deleteRow: function(row) {
      this.layanan.pop(row);
    },
    // software
    tambahSoft: function() {
      this.software.push({
        model: "",
        jumlah: ""
      });
    },
    hapusSoft: function(row) {
      this.software.pop(row);
    },

    // mesin
    newMesin: function() {
      this.mesin.push({
        model: "",
        jumlah: ""
      });
    },

    deleteMesin: function(row) {
      this.mesin.pop(row);
    },

    // Electric
    newElectric: function() {
      this.electric.push({
        model: "",
        jumlah: ""
      });
    },

    deleteElectric: function(row) {
      this.electric.pop(row);
    },
    // Electric
    newSdm: function() {
      this.sdm.push({
        model: "",
        jumlah: ""
      });
    },

    deleteSdm: function(row) {
      this.sdm.pop(row);
    },

    submit() {
      // fix membuat data di masukan ke dalam array
      let key = [];
      this.rows.forEach(row => {
        key.push(row.select);
      });
    },

    send() {
      this.loader = 2;
      window.scroll(0, 1000);
      // layanan
      let Ly = [];
      this.layanan.forEach(index => {
        let layanan = new Object();
        let id = this.idCompany;
        layanan.companyId = id;
        layanan.field = index.field;
        layanan.ability = index.ability;
        Ly.push(layanan);
      });
      // software
      let Sft = [];
      this.software.forEach(key => {
        let soft = new Object();
        let id = this.idCompany;
        soft.companyId = id;
        soft.type = key.modelSoftware;
        soft.information = key.keterangan;
        Sft.push(soft);
      });
      // Mesine
      let Msn = [];
      this.mesin.forEach(key => {
        let m = new Object();
        let id = this.idCompany;
        m.companyId = id;
        m.type = key.modelMesin;
        m.count = key.jumlahMesin;
        Msn.push(m);
      });
      // Electric
      let El = [];
      this.electric.forEach(key => {
        let L = new Object();
        let id = this.idCompany;
        L.companyId = id;
        L.type = key.modelElectric;
        L.count = key.jumlahElectric;
        El.push(L);
      });
      // sdm
      let sdm = [];
      this.sdm.forEach(key => {
        let S = new Object();
        let id = this.idCompany;
        S.companyId = id;
        S.competence = key.role;
        S.localWorkerCount = key.local;
        S.foreignWorkerCount = key.asing;
        sdm.push(S);
      });
      let API = new Object();
      if (Ly[0].field.length > 2) {
        API.Services = Ly;
      }
      if (Msn[0].type.length > 2) {
        API.machines = Msn;
      }
      if (El[0].type.length > 2) {
        API.edms = El;
      }
      if (sdm[0].competence.length > 2) {
        API.humanResources = sdm;
      }
      if (Sft[0].type.length > 2) {
        API.softwares = Sft;
      }

      let url = "companies/" + this.idCompany + "/attributes";
      let type = "PATCH";
      this.dataConection(url, type, API)
        .then(() => {
          this.backTo();
        })
        .catch(error => {
          this.error = error.response.data.message;
          window.scroll(0, 700);
        });
    },

    getCompanyDetail: function() {
      this.id = this.$route.params.idCompany;
      let url = "companies/" + this.idCompany;
      let type = "GET";
      this.conection(url, type)
        .then(response => {
          this.atribut = response.data.result;
        })
        .catch(() => {});
    },

    backTo: function() {
      this.$router.push({
        path: "/machine/labDetailMacinary/" + this.$route.params.idInput
      });
    },

    deleteAtribut: function(key, params) {
      document.getElementById("delProses").click();
      let url = "companies/" + this.idCompany + "/attributes";
      let type = "DELETE";
      let R = {
        attributeId: key,
        key: params
      };
      this.deleteConection(url, type, R)
        .then(() => {
          location.reload();
        })
        .catch(() => {});
    }
  },

  mounted() {
    this.idCompany = this.$route.params.idInput;
    this.role = this.$role;
    this.Token = window.$cookies.get("ACC_MC");
    if (!this.Token) {
      this.Token = this.Token = window.$cookies.get("GuestMacinary");
      if (!this.Token) {
        this.$router.push({ path: "/machine" });
      }
    }
    this.getCompanyDetail();
  }
};
